export default __webpack_public_path__ + "static/pattern-ac2ca21f9b37e456aab1af8665405294.jpg";